import Component from '../app/component'

export default class EventsBarComponent extends Component {
  constructor (el) {
    super(el)
    this.data = {
      index: -1
    }
  }

  init() {
    this.setupIndexes()
    this.setupScroll()
  }

  setupIndexes() {
    if (!this.refs.indexes) {
      return
    }
    const count = this.refs?.items?.length || 0
    for (let i = 0; i < count; i++) {
      const indexEl = document.createElement('li')
      indexEl.addEventListener('pointerup', () => {
        const item = this.refs.items[i]
        this.data.index = i
        this.refs.content.scrollTo({ left: item.offsetLeft })
      })
      indexEl.classList.add(this.refs.indexes.dataset.indexClass)
      this.refs.indexes.appendChild(indexEl)
    }
    this.data.index = 0
  }

  setupScroll() {
    const intObserver = new IntersectionObserver((entries) => {
      entries
        .filter((entry) => entry.isIntersecting)
        .forEach((entry) => {
          this.data.index = this.refs.items.indexOf(entry.target)
        })
    }, {
      threshold: 0.5
    })
    this.refs.items.forEach((el) => intObserver.observe(el))
  }

  watchIndex(value) {
    if (value < 0) {
      return
    }
    const indexesEl = Array.from(this.refs.indexes.querySelectorAll('li'))
    indexesEl.forEach((el) => el.classList.remove(this.refs.indexes.dataset.indexActiveClass))
    indexesEl[value].classList.add(this.refs.indexes.dataset.indexActiveClass)
  }
}
